import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from "@angular/router";
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { State } from 'src/app/unidad-buscar/state/unidad-buscar.selector';
import { MetasModalComponent } from 'src/app/unidad/metas-modal/metas-modal.component';
import { UnidadPageActions } from 'src/app/unidad/state/actions';
import { UnidadService } from 'src/app/unidad/unidad.service';

@Component({
    selector: 'materia-unidades',
    standalone: false,
    templateUrl: 'materia-unidades.component.html',
    styleUrls: ['materia-unidades.component.scss']

})

export class MateriaUnidadesComponent implements OnInit {

    @Input()
    materia: any;
    @Input()
    hijoID: any;

    vm$ = combineLatest([
        this.service.loading$,
        this.service.metasResult$,
        this.service.metasCurricular$,
        this.service.agrupadores$,
      ]).pipe(
        map(
          ([
            loading,
            metas,
            metasCurricular,
            agrupadores,
          ]) => {
            return {
              loading,
              metas,
              metasCurricular,
              agrupadores,
            };
          }
        )
      );
    
    constructor(
        public route: ActivatedRoute,
        public dialog: MatDialog,
        public service: UnidadService,
        private store: Store<State>
    ) { }

    ngOnInit() { }

    openDialog(id: number) {
        // this.service.setUnidadId(id);
        this.store.dispatch(UnidadPageActions.loadUnidadMetas({ idUnidad: id}));
        this.dialog.open(MetasModalComponent, {
            width: '75%',
            data: id,
            },
        );
    }
}
